import React from 'react'

import Box from '@mui/material/Box'
import { useIntl } from 'react-intl'
// ToDo: Create a new alert component
// Task Name: [WEB] - Create an Alert component
// Task ID: 10009695105
// Task Link: https://mortgage-automation-technologies.monday.com/boards/5842126081/pulses/10009695105
import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'

import { LoanUserRow } from '@/components/loanAppDetails/loan-users-table/types'
import Dialog from './Dialog'
import { addSpacesToPascalCase } from '../../services/helpers'

export type ModalShareLoanRevokeProps = {
	visible: boolean
	onClose: () => void
	onSubmit: () => void
	submitting?: boolean
	user?: LoanUserRow
}

const ModalShareLoanRevoke = ({
	visible,
	onClose,
	onSubmit,
	submitting = false,
	user,
}: ModalShareLoanRevokeProps) => {
	const { formatMessage } = useIntl()

	const handleClose = (
		event?: object,
		reason?: 'backdropClick' | 'escapeKeyDown'
	) => {
		if (submitting) return

		if (reason === 'backdropClick') return

		onClose()
	}

	return (
		<Dialog
			open={visible}
			onClose={handleClose}
			maxWidth="sm"
			fullWidth
			title={formatMessage({
				id: 'share_loan.confirm_access_revocation',
			})}
			showActions
			closeButtonProps={{
				text: formatMessage({
					id: 'remove_record.cancel',
				}),
				onClick: handleClose,
				disabled: submitting,
			}}
			submitButtonProps={{
				text: formatMessage({
					id: 'share_loan.revoke_access_loan',
				}),
				onClick: onSubmit,
				loading: submitting,
				disabled: submitting || !user,
				color: 'error',
			}}
		>
			<Alert severity="warning" sx={{ mb: 2 }}>
				{formatMessage({
					id: 'share_loan.undone_message',
				})}
			</Alert>

			{user && (
				<Box sx={{ mt: 2 }}>
					<Typography variant="body1" sx={{ mb: 2 }}>
						{formatMessage({
							id: 'share_loan.revocation_title_question',
						})}
					</Typography>

					<Box
						sx={{
							p: 2,
							border: 1,
							borderColor: 'divider',
							borderRadius: 1,
						}}
					>
						<Typography
							variant="subtitle1"
							sx={{ fontWeight: 'bold', mb: 1 }}
						>
							{user.name}
						</Typography>
						<Box display="flex" gap="4px">
							<Typography
								variant="body2"
								color="text.primary"
								fontWeight={600}
							>
								{formatMessage({
									id: 'global.email',
								})}
								:
							</Typography>
							<Typography variant="body2" color="text.secondary">
								{user.email}
							</Typography>
						</Box>
						<Box display="flex" gap="4px">
							<Typography
								variant="body2"
								color="text.primary"
								fontWeight={600}
							>
								{formatMessage({
									id: 'global.role',
								})}
								:
							</Typography>
							<Typography variant="body2" color="text.secondary">
								{addSpacesToPascalCase(user.role)}
							</Typography>
						</Box>
					</Box>
				</Box>
			)}
		</Dialog>
	)
}

export default ModalShareLoanRevoke
